import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CategoryAirplaySecurityProfileEffects } from './category-airplay-security-profile.effects';
import { categoryAirplaySecurityProfileReducer } from './category-airplay-security-profile.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('categoryAirplaySecurityProfile', categoryAirplaySecurityProfileReducer),
    EffectsModule.forFeature([CategoryAirplaySecurityProfileEffects]),
  ],
  providers: [],
})
export class CategoryAirplaySecurityProfileStoreModule {}
